import { useEffect } from "react";
import { Label, ModalPopup, SofturaTable, SwitchToggle } from "client/CommonComponents";
import MoreOptions from "client/CommonComponents/MoreOptions";
import {
  appOnboardingInitialForm,
  deleteOption,
  editOption,
  viewOption,
} from "client/Components/Administraton/utils/constant";
import './AppListing.scss'
import { useDispatch, useSelector } from "react-redux";
import UserManagementOperations from '../../../../../../redux/UserManagement/operations'
import userManageSelectors from '../../../../../../redux/UserManagement/selectors'
import { setApplicationById } from "redux/UserManagement/action";
import moment from "moment";

const AppListing = (props: any) => {
  const dispatch = useDispatch()
  const dispatchGetApplicationList = UserManagementOperations.dispatchGetApplicationList(dispatch);
  const option = [editOption, viewOption, deleteOption];
  useEffect(() => {
    dispatchGetApplicationList()
    props.setSelectedOption("")
    dispatch(setApplicationById([]))
    dispatch(setApplicationById(appOnboardingInitialForm))
  }, [])
  const {
    applicationListData
  }: any
    = useSelector(
      (state: any) => ({
        applicationListData: userManageSelectors.getApplicationListing(state)
      })
    )
    useEffect(() => {
      applicationListData?.data?.map((item: any, _index: any) => {
        item.lastUpdatedDate= moment(new Date(item?.lastUpdatedDate)).format('MM/DD/YYYY');
      })
    },[applicationListData])
  const appListingColumns = [
    {
      key: "action",
      title: "Action",
      Cell: (row: any) => {
        return (
          <MoreOptions
            onClick={props.optionHandler}
            options={option}
            {...row.rowData}
           data-attribute="AppListing_Default_MoreOptions" />
        );
      },
      width: 35,
    },
    {
      key: "applicationName",
      title: "App Name",
      width: 100,
    },
    {
      key: "appLogoName",
      title: "App Logo",
      width: 150,
    },
    {
      key: "categoryName",
      title: "Category",
      width: 100,
    },
    {
      key: "lastUpdatedDate",
      title: "Last Updated Date",
      width: 100,
    },
    {
      key: "isActive",
      title: "Is Active",
      width: 100,
      Cell: (row: any) => {
        return (
          <SwitchToggle checked={row.rowData.isActive} onChange={() => { }}  data-attribute="AppListing_Default_SwitchToggle" />
        );
      },
    }
  ];

  return (
    <div className="app-grid-container">
      {/* <div className="app-area-header">
        <PrimaryButton
          text="Export To Excel"
          className="pull-right"
          onClick={() => { }}
         data-attribute="AppListing_Default_Button" />
      </div> */}
      <div
        className={
          applicationListData?.data?.length !== 0
            ? "softura-table appOnBoard-table"
            : "softura-table appOnBoard-table paginationNav"
        }
      >
        {props.showDeleteModal ? (
          <ModalPopup
            ShowModalPopupFooter={true}
            ModalPopupTitle="Confirmation"
            ModalPopupType="medium"
            FooterSecondaryBtnTxt="No"
            FooterPrimaryBtnTxt="Yes"
            closeModalPopup={props.handleDeleteModal}
            PrimaryBtnOnclick={props.handleDeleteClick}
            SecondryBtnOnclick={props.handleDeleteModal}
           data-attribute="AppListing_Default_ModalPopup">
            <Label data-attribute="AppListing_Default_Label">Are you sure you want to delete "{props.selectedName}" ?</Label>
          </ModalPopup>
        ) : (
          ""
        )
        }
       <div className="appListInfo-Modal">
        {props.showInfoModal ? (
          <ModalPopup
            ShowModalPopupFooter={true}
            ModalPopupTitle="Information"
            ModalPopupType="medium"
            FooterPrimaryBtnTxt="Ok"
            closeModalPopup={props.handleInfoModal}
            PrimaryBtnOnclick={props.handleInfoModal}
           data-attribute="AppListing_Default_ModalPopup_2">
            <Label data-attribute="AppListing_Default_Label_2">Successfully deleted "{props.selectedName}"</Label>
          </ModalPopup>
        ) : (
          ""
        )
        }
        </div>
        <SofturaTable
          data={applicationListData?.data ?? []}
          columns={appListingColumns}
          sort={true}
          defaultPageSize={10}
          pageSizes={[10, 20, 50]}
          globalSearch={false}
          filter={true}
         data-attribute="AppListing_Default_Grid" />
      </div>
    </div>
  );
};

export default AppListing;
